// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactIdentification_ng5nF {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    padding: 20px;
    width: 92%;
}

.header_VatGg {
    font-size: 1.3rem;
    font-weight: 600;
    color: var(--_10a37f-background);
    margin-bottom: 15px;
    padding-bottom: 8px;
}

.containerForm_biAtQ {
    background: var(--white-background);
    padding: 15px;
    border-radius: 8px;
}

.section_uMAn7 {
    margin-bottom: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.sectionTitle_acd83 {
    font-weight: 600;
    font-size: 15px;
    color: var(--_3-color);
    margin-bottom: 8px;
}

.sectionContent_HkAwN {
    background: red;
}



.checkbox_mzUS3 {
    margin-right: 8px;
}

.divider_J5rmS {
    height: 1px;
    background-color: #e5e5e5;
    margin: 16px 0;
    border: none;
}

.unknown_lma3U {
    color: #8a8a8a;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/contacts/contactIdentification.module.css"],"names":[],"mappings":"AAAA;IACI,yGAAyG;IACzG,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".contactIdentification {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    padding: 20px;\n    width: 92%;\n}\n\n.header {\n    font-size: 1.3rem;\n    font-weight: 600;\n    color: var(--_10a37f-background);\n    margin-bottom: 15px;\n    padding-bottom: 8px;\n}\n\n.containerForm {\n    background: var(--white-background);\n    padding: 15px;\n    border-radius: 8px;\n}\n\n.section {\n    margin-bottom: 24px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.sectionTitle {\n    font-weight: 600;\n    font-size: 15px;\n    color: var(--_3-color);\n    margin-bottom: 8px;\n}\n\n.sectionContent {\n    background: red;\n}\n\n\n\n.checkbox {\n    margin-right: 8px;\n}\n\n.divider {\n    height: 1px;\n    background-color: #e5e5e5;\n    margin: 16px 0;\n    border: none;\n}\n\n.unknown {\n    color: #8a8a8a;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactIdentification": `contactIdentification_ng5nF`,
	"header": `header_VatGg`,
	"containerForm": `containerForm_biAtQ`,
	"section": `section_uMAn7`,
	"sectionTitle": `sectionTitle_acd83`,
	"sectionContent": `sectionContent_HkAwN`,
	"checkbox": `checkbox_mzUS3`,
	"divider": `divider_J5rmS`,
	"unknown": `unknown_lma3U`
};
export default ___CSS_LOADER_EXPORT___;
